














































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import {
  adminContentCampaignShowTabularColumn
} from '@/modules/content-campaign/models/columns/content-campaign-show-tabular.column'
import { ContentCampaignResourceTypeInAdmin } from '@/modules/content-campaign/models/content-campaign-resource.model'
import CampaignStatusView from '@/modules/base-campaign/components/shared/CampaignStatusView.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import AdminContentCampaignTabularActions
  from '@/modules/content-campaign/components/admin/AdminContentCampaignTabularActions.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import { CampaignStatus } from '@/modules/base-campaign/models/base-campaign-resource.model'
import MediaAttachmentDialog from '@/modules/media/components/shared/MediaAttachmentDialog.vue'

@Component({
  components: {
    CampaignStatusView,
    MediaAttachmentDialog,
    TabularHeader,
    AdminCampaignStatus: CampaignStatusView,
    DateTooltipped,
    AdminContentCampaignTabularActions,
    TextEllipsis
  }
})
export default class AdminContentCampaignShowTabular extends Vue {

  @Prop({ required: true }) contentCampaign: ContentCampaignResourceTypeInAdmin
  private columnsData = adminContentCampaignShowTabularColumn()

  get campaign() {
    return this.contentCampaign.data
  }

  private get columns() {
    return this.filterColumns()
  }

  filterColumns() {
    let newList = this.columnsData
    if (this.campaign.references_url === null)
      newList = this.columnsData.filter(col => col.name !== 'references_url')
    if (this.campaign.running_at === null)
      newList = newList.filter(col => col.name !== 'running_at')
    else newList = newList.filter(col => col.name !== 'created_at')
    if (this.campaign.status !== CampaignStatus.COMPLETED)
      newList = newList.filter(col => col.name !== 'completed_at')
    return newList
  }

}
